import { React, useState, useEffect } from "react";
import Box from "@mui/material/Box";
import { api_Routes } from "../../api_Routes";
import { Helper } from "../../tools/Helper";
import Container from "@mui/material/Container";
import Typography from "@mui/material/Typography";
import Grid from "@mui/material/Grid";
import CircularProgress from "@mui/material/CircularProgress";
import { useNavigate } from "react-router-dom";
import MainLoader from "../common/main-loader";
import GroupCard from "./group-card";
import {TablePagination} from "@mui/material";
import blurGroups  from "../../Assets/images/others/blurGroups.png";
import Button from "@mui/material/Button";
const WhatsappGroups = () => {
  const [Groups, setGroups] = useState([]);
  const [currentPage, setCurrentPage] = useState(0);
  const [rowsPerPage, setRowsPerPage] = useState(12);
  const [hasAccess, setHasAccess] = useState(false);
  const [data, setData] = useState([]);
  const navigate = useNavigate();
  const [isLoading, setIsLoading] = useState(true);
  // useEffect(() => {
  //   get_Groups();
  // }, []);

  const get_Groups = async () => {
    const { response, message } = await Helper.Get({
      url: `${api_Routes.SocialGroup.Whatsapp}?per_page=${rowsPerPage}&page=${currentPage + 1}`,
      hasToken: true,
      data: {},
    });
    if (response) {
      setData(response)
      setHasAccess(response?.pagination?.hasAccess)
      setGroups(response.data);

    } else {
    }
    setIsLoading(false);
  };

  const handlePageChange = (event, value) => {
    setCurrentPage(value);
  };

  const handleChangeRowsPerPage = (event) => {
    setRowsPerPage(parseInt(event.target.value, 10));
    setCurrentPage(0);
  };

  useEffect(() => {
    get_Groups();
  }, [ currentPage, rowsPerPage]);


  const goToOurServices = () => {
    window.open(`${window.location.origin}/OurServices/40/77`, '_blank', 'noopener,noreferrer');
  }


  const goToAddPanel = () => {
    window.open(`${window.location.origin}/AddGroup`, '_blank', 'noopener,noreferrer');
  }

  return (
    <>
      <Container
        sx={{
          "@media (min-width: 1200px)": {
            maxWidth: "1400px",
          },
        }}
      >
        {isLoading ? (
          <MainLoader />
        ) : (
          <>
            <Box
              sx={{
                display: "flex",
                justifyContent: "center",
                flexDirection: "column",
                alignItems: "center",
                gap: "16px",
                marginBlock: "60px",
              }}
            >
              <Typography
                sx={{
                  color: "#474747",
                  fontSize: { xs: "20px", sm: "25px", md: "40px" },
                  lineHeight: "40px",
                  fontWeight: "700",
                }}
              >
                That is whatsapp groups
              </Typography>
              <Typography
                sx={{
                  color: "#474747",
                  fontSize: "18px",
                  lineHeight: "20px",
                  fontWeight: "400",
                }}
              >
                By click on any one you will redirect to whatsapp
              </Typography>
            </Box>
            {Groups.length === 0 ? (
              <Box
                display="flex"
                justifyContent="center"
                sx={{
                  flexDirection: { sm: "column", xs: "column", md: "column" },
                  padding: { sm: "30px 100px 230px 100px", xs: "100px 20px" },
                  alignItems: "center",
                  gap: "20px",
                }}
              >
                <Typography
                  sx={{
                    fontWeight: "700",
                    color: "#141414",
                    lineHeight: "32px",
                    fontSize: { xs: "16px", sm: "25px", lg: "32px" },
                    marginBlock: "20px",
                  }}
                >
                  {" "}
                  There is no Groups yet{" "}
                </Typography>
              </Box>
            ) : (
                <>
              <Grid
                container
                spacing={8}
                sx={{
                  marginBottom: "60px",
                  justifyContent: "center",
                }}
              >
                {Groups.map((Group, index) => (
                  <Grid
                    item
                    xs={12}
                    sm={6}
                    md={3}
                    key={index}
                    sx={{
                      position: "relative",
                      marginTop: "60px",
                      paddingTop: "0 !important",
                      paddingLeft: "0 !important",
                    }}
                  >
                    <GroupCard data={Group} />
                  </Grid>
                ))}

              </Grid>
              <div className="mt-4 flex justify-center items-center" style={{placeSelf:'center'}}>
              {
                hasAccess ?
                    <TablePagination
                        page={currentPage}
                        className="mt-auto"
                        onPageChange={handlePageChange}
                        count={data?.pagination?.total}
                        rowsPerPage={rowsPerPage}
                        onRowsPerPageChange={handleChangeRowsPerPage}
                        variant="outlined"
                        shape="rounded"
                        rowsPerPageOptions={[10, 12, 24, 48]}
                    />:
                    <Box
                        display="flex"
                        justifyContent="center"
                        sx={{
                          flexDirection: { sm: "column", xs: "column", md: "column" },
                          padding: { sm: "30px 100px 230px 100px", xs: "100px 20px" },
                          alignItems: "center",
                          gap: "20px",
                        }}
                    >
                      {/* Image wrapper with relative positioning */}
                      <Box sx={{ position: 'relative', display: 'flex', justifyContent: 'center' }}>
                        <img src={blurGroups} alt="Blurred groups" style={{ width: '100%' }} />

                        {/* Centered content container */}
                        <Box sx={{
                          position: 'absolute',
                          top: '50%',
                          left: '50%',
                          transform: 'translate(-50%, -50%)',
                          display: 'flex',
                          flexDirection: 'column',
                          alignItems: 'center',
                          justifyContent: 'center',
                          textAlign: 'center',
                          width: '80%',
                          background: '#4578d74f',
                          borderRadius: '25px',
                          padding: '16px',
                        }}>
                          {/* Text with background */}
                          <Typography
                              sx={{

                                padding: '16px',
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: { xs: '18px', md: '25px' },
                                mb: 2,
                                width: '100%',
                              }}
                          >
                            You Must Purchases Whatsapp groups services from our services
                          </Typography>

                          {/* Button */}
                          <Button
                              variant="contained"
                              onClick={goToOurServices}
                              sx={{
                                backgroundColor: '#4578d7',
                                color: 'white',
                                fontWeight: 'bold',
                                padding: '10px 24px',
                                borderRadius: '25px',
                                '&:hover': {
                                  backgroundColor: '#3a6ac2',
                                }
                              }}
                          >
                            Get More Groups
                          </Button>
                          {/* Text with background */}
                          <Typography
                              sx={{

                                padding: '16px',
                                color: 'white',
                                fontWeight: 'bold',
                                fontSize: { xs: '18px', md: '25px' },
                                mb: 2,
                                width: '100%',
                              }}
                          >
                            You Can also add your Whatsapp Group
                          </Typography>

                          {/* Button */}
                          <Button
                              variant="contained"
                              onClick={goToAddPanel}
                              sx={{
                                backgroundColor: '#4578d7',
                                color: 'white',
                                fontWeight: 'bold',
                                padding: '10px 24px',
                                borderRadius: '25px',
                                '&:hover': {
                                  backgroundColor: '#3a6ac2',
                                }
                              }}
                          >
                            Add you Group
                          </Button>
                        </Box>
                      </Box>
                    </Box>
              }

              </div>
                  </>
            )}
          </>
        )}
      </Container>
    </>
  );
};
export default WhatsappGroups;
